<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        :items="breadcrumb"
        visible-button
        class="d-none d-sm-flex no-print"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb
        :items="breadcrumb"
        v-if="currentStep == steps.edit && updateShowForm == false"
        visible-button
        class="no-print"
      />
    </template>
    <template v-slot:toolbar>
      <div class="white">
        <ToolbarQuotationStepAgro
          class="max-content-width no-print"
          v-if="currentStep != steps.edit && updateShowForm == false"
          :steps-quotation="stepsRuler"
          navigation-enabled
          :max-step="maxNavigableStep"
          :disabled="loadingStatus"
          @clickStep="handleRulerStepClick"
        />
      </div>
    </template>
    <ViewResumeHistorical
      v-if="filteredItemSteps === true"
      @updateShowForm="isShowForm"
      @return="visible"
      class="no-print"
    />
    <QuotationStepProduct
      ref="activeQuotationStep"
      v-if="currentStep == steps.product"
      v-show="updateShowForm == false"
      @updateStep="changeStep"
      :form="formAccordingStep"
      @cancel="cancelQuotationButton"
      class="no-print"
    />
    <QuotationStepRisk
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.risk"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :product="getQuotationProduct"
      :subProduct="getSubProduct"
      :readonly-form="getForm('quotation step risk')"
      @cancel="cancelQuotationButton"
    />
    <QuotationStepInsured
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.insured"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :readonly-form="getForm('quotation step insured')"
      @cancel="cancelQuotationButton"
    />
    <QuotationStepCosts
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.costs"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :formCost="itemSteps[3].form"
      :readonly-form="getForm('quotation step costs')"
      :options-quotation="optionsQuotation"
      :modality="itemSteps[0].form.modality.id"
      @cancel="cancelQuotationButton"
    />
    <QuotationStepCostsViewer
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.aproveCosts"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :formProduct="itemSteps[0].form"
      :formCost="itemSteps[3].form"
      :formInsured="itemSteps[2].form"
      :formRisk="itemSteps[1].form"
      :readonly-form="getForm('quotation step aproveCosts')"
      :options-quotation="optionsQuotation"
      :modality="itemSteps[0].form.modality.id"
      @cancel="cancelQuotationButton"
    />
    <QuotationStepInsured2
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.insured2"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :formInsured="itemSteps[2].form"
      :formLocation="itemSteps[1].form"
      :readonly-form="getForm('quotation step insured2')"
      @cancel="cancelQuotationButton"
    />
    <QuotationStepRisk2
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.risk2"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :formInsured="itemSteps[2].form"
      :formLocation="itemSteps[1].form"
      :readonly-form="getForm('quotation step risk2')"
      @cancel="cancelQuotationButton"
    />
    <QuotationStepProposal
      :navigation-draft="navigationDrafts[steps.proposal]"
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.proposal"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :product="itemSteps[0].form.modality.id"
      :formCosts="getForm(steps.aproveCosts)"
    />
    <QuotationStepAgreement
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.agreement"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :product="itemSteps[0].form.modality.id"
      :readonly-form="getForm('quotation step agreement')"
    />
    <QuotationStepPolicy
      :navigation-draft="navigationDrafts[steps.policy]"
      ref="activeQuotationStep"
      v-show="updateShowForm == false"
      v-if="currentStep == steps.policy"
      @updateStep="changeStep"
      :form="formAccordingStep"
      :product="itemSteps[0].form.modality.id"
      :formProposal="getForm(steps.proposal)"
    />
    <ModalCancelQuotation
      v-show="updateShowForm == false"
      @close="closeModal"
      v-model="modalCancel"
      class="no-print"
    />
  </Main>
</template>
<script>
import QuotationStepProduct from "../new_quotation_steps_agro/QuotationStepProduct";
import QuotationStepRisk from "../new_quotation_steps_agro/QuotationStepRisk";
import QuotationStepRisk2 from "../new_quotation_steps_agro/QuotationStepRisk2";
import QuotationStepInsured from "../new_quotation_steps_agro/QuotationStepInsured";
import QuotationStepInsured2 from "../new_quotation_steps_agro/QuotationStepInsured2";
import QuotationStepProposal from "../new_quotation_steps_agro/QuotationStepProposal";
import QuotationStepCosts from "../new_quotation_steps_agro/QuotationStepCosts";
import QuotationStepCostsViewer from "../new_quotation_steps_agro/QuotationStepCostsViewer";
import QuotationStepAgreement from "../new_quotation_steps_agro/QuotationStepAgreement";
import QuotationStepPolicy from "../new_quotation_steps_agro/QuotationStepPolicy";
import ModalCancelQuotation from "../components/ModalCancelQuotation";
import ViewResumeHistorical from "../components_agro/ViewResumeHistorical.vue";
import ToolbarQuotationStepAgro from "../components_agro/ToolbarQuotationStepAgro.vue";
import { mapState, mapActions } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { formatIsoDateToDDMMYYYYProper } from "@/utils/formats.js";
import _ from "lodash";
const tabSteps = {
  product: "quotation step product",
  risk: "quotation step risk",
  insured: "quotation step insured",
  costs: "quotation step costs",
  aproveCosts: "quotation step aproveCosts",
  insured2: "quotation step insured2",
  risk2: "quotation step risk2",
  proposal: "quotation step proposal",
  agreement: "quotation step agreement",
  policy: "quotation step policy"
};
const itemSteps = [
  {
    form: {
      modality: null,
      subModality: null,
      taker: null
    },
    step: tabSteps.product
  },
  {
    form: {
      agricola: {
        items: []
      },
      cafezal: {
        items: []
      },
      endereco: {
        cep: null,
        uf: {
          sigla: null,
          nome: null
        },
        cidade: null,
        coordenadas: null,
        kmlFiles: []
      }
    },
    step: tabSteps.risk
  },
  {
    form: {
      numero_documento: null,
      nome: null,
      email: null,
      phone: null,
      credito_rural: {
        is_credito_rural: false,
        documento_beneficiario: null,
        nome_beneficiario: null,
        valor_credito_rural: 0
      }
    },
    step: tabSteps.insured
  },
  {
    form: {
      numero_cotacao: null,
      textInput: null,
      quotationCosts: [],
      quotationCostsCafezal: []
    },
    step: tabSteps.costs
  },
  {
    form: {
      avista_parcelado: null,
      forma_pagamento: null,
      selectedCost: null
    },
    step: tabSteps.aproveCosts
  },
  {
    form: {
      estado_civil: null,
      data_nascimento: null,
      genero: {
        sigla: null,
        nome: null
      },
      tipo_documento: {
        id: null,
        nome: null
      },
      numero_documento_extra: null,
      orgao_expedidor: null,
      data_expedicao: null,
      endereco: {
        cep: null,
        cidade: null,
        uf: {
          sigla: null,
          nome: null
        },
        bairro: null,
        logradouro: null,
        numero: null,
        complemento: null
      },
      dados_bancarios: {
        banco: {
          id: null,
          nome: null
        },
        agencia: null,
        conta: null
      }
    },
    step: tabSteps.insured2
  },
  {
    form: {
      areas: []
    },
    step: tabSteps.risk2
  },
  {
    form: {},
    step: tabSteps.proposal
  },
  {
    form: {
      cards: []
    },
    step: tabSteps.agreement
  },
  {
    form: {},
    step: tabSteps.policy
  }
];
const firstStep = {
  name: tabSteps.product,
  step: 1
};
const STEP_ONE_QUOTATION = {
  name: "1. Produto",
  router: "quotation step product",
  step: 1
};
const STEP_TWO_QUOTATION = {
  name: "2. Dados do risco",
  router: "quotation step risk",
  step: 2
};
const STEP_THREE_QUOTATION = {
  name: "3. Dados do Segurado",
  router: "quotation step insured",
  step: 3,
  status: ["aguardando_cotacao", "aguardando_confirmacao_usuario"]
};
const STEP_FOUR_QUOTATION = {
  name: "4. Cotações",
  router: "quotation step costs",
  step: 4,
  status: ["aguardando_aprovacao_cotacao"]
};
const STEP_FIVE_QUOTATION = {
  name: "5. Aprovação",
  router: "quotation step aproveCosts",
  step: 5,
  status: ["aguardando_dados_segurado"]
};
const STEP_SIX_QUOTATION = {
  name: "1. Dados do Segurado",
  router: "quotation step insured2",
  step: 6,
  status: ["aguardando_dados_risco"]
};
const STEP_SEVEN_QUOTATION = {
  name: "2. Dados do Risco",
  router: "quotation step risk2",
  step: 7,
  status: ["aguardando_proposta", "proposta_emitida"]
};
const STEP_EIGHT_QUOTATION = {
  name: "3. Proposta",
  router: "quotation step proposal",
  step: 8,
  status: ["aguardando_conformidade"]
};
const STEP_NINE_QUOTATION = {
  name: "4. Conformidade",
  router: "quotation step agreement",
  step: 9,
  status: ["aguardando_emissao_apolice"]
};
const STEP_TEN_QUOTATION = {
  name: "5. Apólice",
  router: "quotation step policy",
  step: 10,
  status: ["apolice_emitida"]
};
const DONE_QUOTATION = {
  name: "5. Apólice",
  router: "quotation step policy",
  step: 11
};
export default {
  name: "NewQuotationAgro",
  beforeRouteLeave(to, from, next) {
    if (
      (this.currentStep == "quotation step costs" && !this.quotationId) ||
      this.itemSteps[0].form.modality == null ||
      this.currentStep == "quotation edit"
    )
      next();
    this.modalCancel = true;
    this.nextRoute = to;
    if (this.cancel) next();
  },
  data: () => ({
    DONE_QUOTATION,
    updateShowForm: false,
    isVisible: true,
    filteredItemSteps: false,
    formatIsoDateToDDMMYYYYProper,
    currentStep: "quotation step product",
    steps: tabSteps,
    itemSteps: {},
    cancel: false,
    modalCancel: false,
    previousStep: "quotation step product",
    currentSubmodality: {},
    uploadQuotationError: false,
    numeroSolicitacao: null,
    produto: null,
    cultura: null,
    breadcrumb: [
      {
        text: "Editar dados",
        to: "quotation element"
      }
    ],
    navigationDrafts: {},
    maxNavigableStep: 1,
    quotationId: null
  }),
  props: {
    groupId: {
      type: String
    },
    officeId: {
      type: String
    },
    optionsQuotation: {
      type: Object
    }
  },
  components: {
    ToolbarQuotationStepAgro,
    QuotationStepProduct,
    QuotationStepRisk,
    QuotationStepRisk2,
    QuotationStepInsured,
    QuotationStepInsured2,
    QuotationStepProposal,
    QuotationStepCosts,
    QuotationStepCostsViewer,
    ModalCancelQuotation,
    //QuotationEditForm
    QuotationStepAgreement,
    QuotationStepPolicy,
    ViewResumeHistorical
  },
  mixins: [QuotationMixin, LoadingRequest],
  computed: {
    ...mapState("quotation", ["infoCostQuotation", "currentQuotation"]),
    ...mapState(["showMiniBarMenu", "loadingStatus"]),
    ...mapState("me", ["userIsGuest"]),
    formAccordingStep() {
      return this.itemSteps.find(x => x.step == this.currentStep).form;
    },
    currentStepIndex() {
      return this.itemSteps.findIndex(x => x.step == this.currentStep);
    },
    stepsQuotation() {
      return [
        STEP_ONE_QUOTATION,
        STEP_TWO_QUOTATION,
        STEP_THREE_QUOTATION,
        STEP_FOUR_QUOTATION,
        STEP_FIVE_QUOTATION,
        STEP_SIX_QUOTATION,
        STEP_SEVEN_QUOTATION,
        STEP_EIGHT_QUOTATION,
        STEP_NINE_QUOTATION,
        STEP_TEN_QUOTATION
      ];
    },
    stepsRuler() {
      const split = 5;
      const stepIndex = this.stepsQuotation.findIndex(
        x => x.router === this.currentStep
      );
      if (stepIndex < split) {
        return this.stepsQuotation.slice(0, split);
      } else {
        return this.stepsQuotation.slice(split - this.stepsQuotation.length);
      }
    },
    getQuotationProduct() {
      return this.getForm("quotation step product")?.modality;
    },
    getProduct() {
      return this.itemSteps[0]?.form?.subModality?.id;
    },
    getSubProduct() {
      return this.getForm("quotation step product")?.subModality;
    },
    isResuming() {
      return this.$route.params?.id != null;
    }
  },
  async created() {
    this.itemSteps = _.cloneDeep(itemSteps);
    this.currentStep = null;
    if (this.isResuming) {
      await this.withLoading(await this.resumeQuotation(this.$route.params.id, null));
    } else {
      this.currentStep = firstStep.name;
      this.itemSteps = _.cloneDeep(itemSteps);
      this.updateCurrentQuotationStep(firstStep);
    }
    this.updateBreadCrumb();
    this.setShowMiniBarMenu(true);
  },
  methods: {
    ...mapActions("quotation", [
      "updateCurrentQuotationStep",
      "makeNewQuotationAgro",
      "makeContractDataQuotationAgro",
      "requestEditQuotation",
      "requestCancelQuotationAgro",
      "requestCurrentQuotationAgro",
      "postQuotationCostsAgro",
      "requestAgroAgreement",
      "requestCafezalAgreement"
    ]),
    ...mapActions(["showAlertNotification"]),
    ...mapActions(["setShowMiniBarMenu"]),
    handleRulerStepClick(targetStep) {
      const destination = this.stepsRuler.find(
        step => step.router === targetStep?.router
      );
      if (
        this.loadingStatus ||
        !destination ||
        destination.router === this.currentStep ||
        destination.step > this.maxNavigableStep
      ) {
        return;
      }

      const activeStep = this.$refs.activeQuotationStep;
      const currentForm = activeStep.getFormForNavigation();
      this.itemSteps[this.currentStepIndex].form = currentForm;

      if (activeStep.$refs.formEl) {
        this.$set(
          this.navigationDrafts,
          this.currentStep,
          _.cloneDeep(activeStep.$refs.formEl.editForm)
        );
      }

      this.filteredItemSteps = destination.step > 3;
      this.previousStep = this.currentStep;
      this.currentStep = destination.router;
      this.updateCurrentQuotationStep(destination);
      this.updateBreadCrumb();
    },
    async resumeQuotation(id, step) {
      if (this.userIsGuest) {
        return;
      }
      if (id != null) {
        this.withLoading(this.requestCurrentQuotationAgro(id)).then(() => {
          this.loadQuotationData(this.currentQuotation, step);
        });
      }
    },
    getStepIndexByStatus(status) {
      return this.stepsQuotation.findIndex(
        step => Array.isArray(step.status) && step.status.includes(status)
      );
    },
    isShowForm() {
      this.updateShowForm = true;
    },
    visible() {
      this.updateShowForm = false;
    },
    loadQuotationData(data, step) {
      let forms = _.cloneDeep(itemSteps);
      let stepIndex = 0;
      let maxStep = this.getStepIndexByStatus(data.status?.id);
      if (maxStep == -1) {
        this.$router.push({ name: "quotation" });
        return;
      }

      if (data.numero != null) {
        this.numeroSolicitacao = data.numero;
        this.produto = data.modalidade.nome;
        this.cultura = data.submodalidade.nome;
      }
      // Produto
      stepIndex = forms.findIndex(x => x.step == tabSteps.product);
      forms[stepIndex].form = {
        modality: { id: data.modalidade.id },
        subModality: { id: data.submodalidade.id }
      };
      this.currentSubmodality = data.submodalidade.id;
      // Area do Risco
      stepIndex = forms.findIndex(x => x.step == tabSteps.risk);
      let itensAgricola = [];
      if (data.itens_agricola != null) {
        data.itens_agricola.forEach(x => {
          let kmlFiles = [];
          x.coordenadas_kml.forEach(item => {
            kmlFiles.push({
              url: item.arquivo_link,
              nome: item.arquivo_nome
            });
          });
          itensAgricola.push({
            id: x.id,
            nome: x.nome,
            plantedArea: x.area_plantada,
            plantingTechniques: {
              id: x.tecnica_plantio.id,
              nome: x.tecnica_plantio.name
            },
            soilType: {
              id: x.classificacao_solo.id,
              nome: x.classificacao_solo.nome
            },
            plantingDate: this.formatIsoDateToDDMMYYYYProper(x.data_plantio),
            claimCurrentHarvest: x.reivindicar_colheita_atual,
            alreadyPlanted: x.plantado,
            yearsPlanting: x.primeiro_ano_plantio,
            soyAfterSuggarCane: x.soja_apos_cana_acucar,
            coordenadas: x.coordenadas,
            kmlFiles: kmlFiles
          });
        });
      }
      let itensCafezal = [];
      if (data.itens_cafezal != null) {
        data.itens_cafezal.forEach(x => {
          let kmlFiles = [];
          x.coordenadas_kml.forEach(item => {
            kmlFiles.push({
              url: item.arquivo_link,
              nome: item.arquivo_nome
            });
          });
          itensCafezal.push({
            id: x.id,
            nome: x.nome,
            areaPlantada: x.area_plantada,
            especie: {
              id: x.especie_cafe.id,
              nome: x.especie_cafe.name
            },
            variedade: {
              id: x.variedade_cafe.id,
              nome: x.variedade_cafe.name
            },
            sistemaCultivo: {
              id: x.sistema_cultivo_cafe.id,
              nome: x.sistema_cultivo_cafe.name
            },
            idade: x.idade,
            espacamentoPlantas: x.espacamento_plantas,
            espacamentoLinhas: x.espacamento_linhas,
            plantasPorHectare: x.planta_hectare,
            dataUltimaRecepa:
              x.data_ultima_recepa != null
                ? this.formatIsoDateToDDMMYYYYProper(x.data_ultima_recepa)
                : null,
            danosNoCiclo: x.danos_ciclo,
            coordenadas: x.coordenadas,
            kmlFiles: kmlFiles,
            percentual_pos_normal: x.percentual_pos_normal,
            percentual_pos_reduzida: x.percentual_pos_reduzida
          });
        });
      }
      forms[stepIndex].form = {
        agricola: {
          items: itensAgricola
        },
        cafezal: {
          items: itensCafezal
        },
        endereco: {
          cep: data.area_risco.cep,
          uf: {
            sigla: data.area_risco.uf?.id,
            nome: data.area_risco.uf?.name
          },
          cidade: data.area_risco?.cidade,
          coordenadas: [],
          kmlFiles: []
        }
      };
      // Segurado
      stepIndex = forms.findIndex(x => x.step == tabSteps.insured);
      forms[stepIndex].form = {
        numero_documento: data.segurado.numero_documento,
        nome: data.segurado.nome,
        email: data.segurado.email,
        celular: data.segurado.celular,
        credito_rural: {
          is_credito_rural: data.valor_credito_rural != null,
          documento_beneficiario: data.documento_credito_rural,
          nome_beneficiario: data.nome_credito_rural,
          valor_credito_rural: data.valor_credito_rural
        }
      };
      let selectedCost = null;
      stepIndex = forms.findIndex(x => x.step == tabSteps.costs);
      // Custos
      forms[stepIndex].form = {
        numero_cotacao: data.id,
        textInput: data.informacoes_adicionais,
        quotationCosts: [],
        quotationCostsCafezal: []
      };
      if (maxStep >= stepIndex) {
        let quotationCosts = [];
        //custo agro
        if (data.custos.length > 0) {
          selectedCost = data.custos.filter(x => x.aprovada_em != null);
          selectedCost = selectedCost.length > 0 ? selectedCost[0] : null;
          for (let i = 0; i < data.custos.length; i++) {
            let custo = data.custos[i];
            quotationCosts.push({
              id: custo.id,
              insuranceType: {
                id: custo.tipo_seguro.id,
                nome: custo.tipo_seguro.name
              },
              insuranceCompany: custo.seguradora,
              insuredArea: custo.area_segurada,
              claimType: {
                id: custo.tipo_reivindicacao.id,
                nome: custo.tipo_reivindicacao.name
              },
              coverage: {
                id: custo.tipo_cobertura.id,
                nome: custo.tipo_cobertura.name
              },
              insuredValue: custo.importancia_segurada,
              grantedProduction: custo.producao_garantida,
              costPerSac: custo.custo_por_saca,
              hectareCost: custo.custo_por_hectare,
              total: custo.custo_total,
              comissao: custo.comissao,
              federalSubvention: custo?.subvencao_federal,
              stateSubvention: custo?.subvencao_estadual,
              insuredPrice: custo.custo_segurado,
              farmerPrice: custo.custo_produtor,
              paymentForm: {
                id: custo.forma_pagamento.id,
                nome: custo.forma_pagamento.name
              }
            });
          }
        }
        //custo cafezal
        let quotationCostsCafezal = [];
        if (data.custos_cafezal.length > 0) {
          selectedCost = data.custos_cafezal.filter(x => x.aprovada_em != null);
          selectedCost = selectedCost.length > 0 ? selectedCost[0] : null;
          for (let i = 0; i < data.custos_cafezal.length; i++) {
            let custoCafezal = data.custos_cafezal[i];
            quotationCostsCafezal.push({
              id: custoCafezal.id,
              seguradora: custoCafezal.seguradora,
              area_segurada: custoCafezal.area_segurada,
              valor_planta: custoCafezal.valor_planta,
              granizo: custoCafezal.granizo,
              granizo_geada: custoCafezal.granizo_geada,
              perda_producao_futura: custoCafezal.perda_producao_futura,
              tratamento_fitossanitario: custoCafezal.tratamento_fitossanitario,
              paymentForm: {
                id: custoCafezal.forma_pagamento.id,
                nome: custoCafezal.forma_pagamento.name
              },
              tipo_pos: {
                id: custoCafezal.tipo_pos.id,
                nome: custoCafezal.tipo_pos.name
              },
              premio_total: custoCafezal.premio_total,
              comissao: custoCafezal.comissao,
              subvencao_federal: custoCafezal.subvencao_federal,
              subvencao_estadual: custoCafezal.subvencao_estadual,
              premio_segurado: custoCafezal.premio_segurado,
              investimento: custoCafezal.investimento
            });
          }
        }
        forms[stepIndex].form.quotationCosts = quotationCosts;
        forms[stepIndex].form.quotationCostsCafezal = quotationCostsCafezal;
      }
      // Aprovação dos custos
      stepIndex = forms.findIndex(x => x.step == tabSteps.aproveCosts);
      if (maxStep >= stepIndex) {
        forms[stepIndex].form = {
          forma_pagamento: {
            id: data.forma_pagamento?.id,
            name: data.forma_pagamento?.name
          },
          selectedCost: selectedCost
        };
      }
      // Fluxo contratacao Segurado 2
      stepIndex = forms.findIndex(x => x.step == tabSteps.insured2);
      // segurado n precisa de if pq os dados podem ter sido preenchidos anteriormente
      forms[stepIndex].form = {
        numero_documento_extra: data.segurado.numero_documento_extra,
        tipo_documento: data.segurado.tipo_documento
          ? {
              id: data.segurado.tipo_documento.id,
              nome: data.segurado.tipo_documento.name
            }
          : null,
        data_expedicao: data.segurado.data_expedicao
          ? formatIsoDateToDDMMYYYYProper(data.segurado.data_expedicao)
          : null,
        orgao_expedidor: data.segurado.orgao_expedidor,
        genero: data.segurado.genero
          ? {
              sigla: data.segurado.genero.id,
              nome: data.segurado.genero.name
            }
          : null,
        data_nascimento: data.segurado.data_nascimento
          ? formatIsoDateToDDMMYYYYProper(data.segurado.data_nascimento)
          : null,
        estado_civil: data.segurado.estado_civil
          ? {
              id: data.segurado.estado_civil.id,
              nome: data.segurado.estado_civil.name
            }
          : null,
        endereco: {
          logradouro: data.segurado.endereco?.logradouro,
          numero: data.segurado.endereco?.numero,
          bairro: data.segurado.endereco?.bairro,
          complemento: data.segurado.endereco?.complemento,
          cidade: data.segurado.endereco?.cidade,
          cep: data.segurado.endereco?.cep,
          uf: {
            sigla: data.segurado.endereco?.uf?.id,
            nome: data.segurado.endereco?.uf?.name
          }
        },
        dados_bancarios: {
          banco: {
            id: data.segurado.dados_bancarios?.banco.id,
            nome: data.segurado.dados_bancarios?.banco.name
          },
          agencia: data.segurado.dados_bancarios?.agencia,
          conta: data.segurado.dados_bancarios?.conta
        }
      };
      // Fluxo contratacao Risk Area 2 - agrícola
      stepIndex = forms.findIndex(x => x.step == tabSteps.risk2);
      if (maxStep >= stepIndex) {
        itensAgricola = [];
        data.itens_agricola.forEach(x => {
          let kmlFiles = [];
          x.coordenadas_kml.forEach(item => {
            kmlFiles.push({
              url: item.arquivo_link,
              nome: item.arquivo_nome
            });
          });
          itensAgricola.push({
            id: x.id,
            nome: x.nome,
            plantedArea: x.area_plantada,
            plantingTechniques: {
              id: x.tecnica_plantio.id,
              nome: x.tecnica_plantio.name
            },
            soilType: {
              id: x.classificacao_solo.id,
              nome: x.classificacao_solo.nome
            },
            plantingDate: this.formatIsoDateToDDMMYYYYProper(x.data_plantio),
            claimCurrentHarvest: x.reivindicar_colheita_atual,
            alreadyPlanted: x.plantado,
            yearsPlanting: x.primeiro_ano_plantio,
            soyAfterSuggarCane: x.soja_apos_cana_acucar,
            logradouro: x.endereco?.logradouro,
            numero: x.endereco?.numero,
            bairro: x.endereco?.bairro,
            complemento: x.endereco?.complemento,
            cidade: x.endereco?.cidade,
            cep: x.endereco?.cep,
            uf: {
              sigla: x.endereco?.uf?.id,
              nome: x.endereco?.uf?.name
            },
            car: x.car,
            roteiro_acesso: x.roteiro_acesso,
            coordenadas: x.coordenadas,
            kmlFiles: kmlFiles
          });
        });
        itensCafezal = [];
        if (data.itens_cafezal != null) {
          data.itens_cafezal.forEach(x => {
            let kmlFiles = [];
            x.coordenadas_kml.forEach(item => {
              kmlFiles.push({
                url: item.arquivo_link,
                nome: item.arquivo_nome
              });
            });
            itensCafezal.push({
              id: x.id,
              nome: x.nome,
              areaPlantada: x.area_plantada,
              especie: {
                id: x.especie_cafe.id,
                nome: x.especie_cafe.name
              },
              variedade: {
                id: x.variedade_cafe.id,
                nome: x.variedade_cafe.name
              },
              sistemaCultivo: {
                id: x.sistema_cultivo_cafe.id,
                nome: x.sistema_cultivo_cafe.name
              },
              idade: x.idade,
              espacamentoPlantas: x.espacamento_plantas,
              espacamentoLinhas: x.espacamento_linhas,
              plantasPorHectare: x.planta_hectare,
              dataUltimaRecepa: x.data_ultima_recepa,
              danosNoCiclo: x.danos_ciclo,
              coordenadas: x.coordenadas,
              kmlFiles: kmlFiles,
              percentual_pos_normal: x.percentual_pos_normal,
              percentual_pos_reduzida: x.percentual_pos_reduzida,
              logradouro: x.endereco?.logradouro,
              numero: x.endereco?.numero,
              bairro: x.endereco?.bairro,
              complemento: x.endereco?.complemento,
              cidade: x.endereco?.cidade,
              cep: x.endereco?.cep,
              uf: {
                sigla: x.endereco?.uf?.id,
                nome: x.endereco?.uf?.name
              }
            });
          });
        }
      }
      forms[stepIndex].form = {
        areas: itensAgricola.length > 0 ? itensAgricola : itensCafezal
      };
      // Fluxo Contratação - Proposta
      stepIndex = forms.findIndex(x => x.step == tabSteps.proposal);
      if (maxStep >= stepIndex) {
        forms[stepIndex].form = _.cloneDeep(selectedCost);
      }
      // Carrega dados de Conformidade
      stepIndex = forms.findIndex(x => x.step == tabSteps.agreement);
      if (selectedCost && selectedCost.documentos_conformidade != null) {
        let cards = [];
        selectedCost.documentos_conformidade.forEach(item => {
          let arquivo = null;
          if (item.arquivo_link != null && item.arquivo_nome != null) {
            arquivo = {
              url: item.arquivo_link,
              nome: item.arquivo_nome
            };
          }
          cards.push({
            id: item.id,
            custo_agro_id: item.cotacao_custo_agro_id,
            custos_cafezal_id: item.cotacao_custo_cafezal_id,
            file: arquivo == null ? [] : [arquivo],
            status: {
              id: item.status.id,
              nome: item.status.name
            },
            tipo_conformidade: {
              id: item.tipo_conformidade.id,
              nome: item.tipo_conformidade.name
            },
            justificativa: item.justificativa
          });
        });
        forms[stepIndex].form = {
          cards: cards
        };
      }
      // Fluxo Contratação - Apolice Inserida
      stepIndex = forms.findIndex(x => x.step == tabSteps.policy);
      if (maxStep >= stepIndex) {
        forms[stepIndex].form = _.cloneDeep(selectedCost);
      }
      // Fim da carga dos dados e redireciona para o ultimo passo
      let nextStep;
      const nextIndex = maxStep + 1;
      // Verifica se tem próximo passo válido
      if (nextIndex < this.stepsQuotation.length) {
        nextStep = this.stepsQuotation[nextIndex];
      } else {
        nextStep = this.DONE_QUOTATION;
      }
      this.navigationDrafts = {};
      this.maxNavigableStep = Math.min(nextStep.step, this.stepsQuotation.length);

      // Aplica filtro apenas se for o próximo passo ou null
      if (step === null || nextIndex === step) {
        this.filteredItemSteps = nextStep.step > 3;
      }
      // Altera o passo atual para o ultimo carregado:
      this.itemSteps = _.cloneDeep(forms);
      this.currentStep = nextStep.router;
      this.updateCurrentQuotationStep(nextStep);
      this.updateBreadCrumb();
    },
    async changeStep(payload) {
      this.$delete(this.navigationDrafts, this.currentStep);
      if (payload.step.step > 3) {
        this.filteredItemSteps = true;
      } else {
        this.filteredItemSteps = false;
      }

      // Quando é concluída a etapa de dados do segurado, cria a cotação na db.
      if (
        this.currentStep == tabSteps.insured &&
        payload.step.name == tabSteps.costs
      ) {
        await this.uploadNewQuotation(payload);
        return;
      }

      // Quando é concluída a etapa de criação das propostas, é preciso enviar p/ a db.
      if (
        this.currentStep == tabSteps.costs &&
        payload.step.name == tabSteps.aproveCosts &&
        this.currentQuotation.id != null
      ) {
        payload.form.numero_cotacao = this.currentQuotation.id;
        await this.withLoading(this.submitQuotationCostsAgro(payload));
        return;
      }

      if (
        this.currentStep == tabSteps.insured2 &&
        payload.step.name == tabSteps.risk2
      ) {
        await this.uploadContractDataQuotation(payload);
      }

      if (
        this.currentStep == tabSteps.risk2 &&
        payload.step.name == tabSteps.proposal
      ) {
        await this.uploadContractDataQuotation(payload);
      }

      //agricola
      if (
        this.currentStep == tabSteps.proposal &&
        payload.step.name == tabSteps.agreement &&
        this.itemSteps[0].form.modality.id == "agricola"
      ) {
        await this.requestAgroAgreement(payload).then(() => {
          this.resumeQuotation(payload.form.cotacao_id, payload.step.step);
        });
      }

      //cafezal
      if (
        this.currentStep == tabSteps.proposal &&
        payload.step.name == tabSteps.agreement &&
        this.itemSteps[0].form.modality.id == "cafezal"
      ) {
        await this.requestCafezalAgreement(payload).then(() => {
          this.resumeQuotation(payload.form.cotacao_id, payload.step.step);
        });
      }

      this.itemSteps.find(x => x.step == this.currentStep).form = payload.form;
      this.previousStep = _.cloneDeep(this.currentStep);
      this.currentStep = payload.step.name;
      this.maxNavigableStep = Math.max(this.maxNavigableStep, payload.step.step);
      this.updateCurrentQuotationStep(payload.step);
      this.updateBreadCrumb();
    },
    async submitQuotationCostsAgro(payload) {
      await this.postQuotationCostsAgro(await this.formatQuotationCostsAgro(payload))
        .then(() => {
          this.resumeQuotation(payload.form.numero_cotacao, payload.step.step);
        })
        .catch(e => {
          console.error("erro salvando custos", e);
        });
    },
    async putQuotationAgro(payload) {
      this.withLoading(
        this.requestPutCurrentQuotationAgro(
          await this.getPayloadNewQuotationAgro(payload)
        )
          .then(() => {
            this.resumeQuotation(payload.form.numero_cotacao, payload.step.step);
          })
          .catch(e => {
            console.error("erro salvando custos", e);
          })
      );
    },
    cancelQuotationButton() {
      this.cancel = false;
      this.modalCancel = true;
    },
    closeModal(value) {
      let quotationId = this.$route.params.id
        ? this.$route.params.id
        : this.infoCostQuotation.id;
      if (quotationId != null && value == true) {
        this.withLoading(
          this.requestCancelQuotationAgro(quotationId).then(() => {
            this.cancel = true;
            return this.loadQuotationData(this.currentQuotation);
          })
        );
      } else {
        this.$router.push({ name: "quotation" });
      }
      this.modalCancel = false;
    },
    getForm(item) {
      return this.itemSteps.find(x => x.step == item).form;
    },
    async uploadNewQuotation(payload) {
      this.itemSteps.find(x => x.step == this.currentStep).form = payload.form;

      await this.withLoading(
        this.makeNewQuotationAgro(
          await this.getPayloadNewQuotationAgro(this.itemSteps)
        ).then(currentQuotation => {
          let quotationId = this.$route.params.id;
          if (!this.userIsGuest) {
            if (quotationId == null) {
              this.$router.push({
                name: "quotation element",
                params: { id: currentQuotation.id }
              });
            } else {
              this.resumeQuotation(this.currentQuotation.id, payload.step.step);
            }
          }
        })
      ).catch(() => {
        this.uploadQuotationError = true;
      });

      // aguarda 100ms pra não retornar antes de executar o catch() caso haja algum erro.
      await new Promise(resolve => setTimeout(resolve, 100));
    },
    async uploadContractDataQuotation(payload) {
      this.itemSteps.find(x => x.step == this.currentStep).form = payload.form;

      await this.withLoading(
        this.makeContractDataQuotationAgro(
          await this.getPayloadNewQuotationAgro(this.itemSteps)
        ).then(currentQuotation => {
          let quotationId = this.$route.params.id;
          if (!this.userIsGuest) {
            if (quotationId == null) {
              this.$router.push({
                name: "quotation element",
                params: { id: currentQuotation.id }
              });
            } else {
              this.resumeQuotation(this.currentQuotation.id, payload.step.step);
            }
          }
        })
      ).catch(() => {
        this.uploadQuotationError = true;
      });

      // aguarda 100ms pra não retornar antes de executar o catch() caso haja algum erro.
      await new Promise(resolve => setTimeout(resolve, 100));
    },
    async getEditPayload(form, id) {
      form.anexos = await this.submitFiles(form.anexos);
      return {
        id: id,
        payload: form
      };
    },
    changeToCostStep() {
      this.currentStep = "quotation step cost";
    },
    cancelProcess(id) {
      this.quotationId = id;
      this.$router.push({ name: "quotation" });
    },
    updateBreadCrumb() {
      let textBread;

      if (this.currentStep === this.step?.edit) {
        textBread = "Editar dados";
      } else {
        textBread = this.numeroSolicitacao
          ? `Solicitação - ${this.numeroSolicitacao} - ${this.produto} - ${this.cultura}`
          : "Solicitação";
      }

      this.breadcrumb = [
        {
          text: textBread,
          to: "quotation element"
        }
      ];
    }
  },
  watch: {
    getProduct(newValue) {
      if (
        this.currentStep == firstStep.step &&
        this.currentSubmodality != newValue
      ) {
        this.currentSubmodality = newValue;
        let newQuotation = _.cloneDeep(itemSteps);
        newQuotation[0] = this.itemSteps[0];
        this.itemSteps = newQuotation;
      }
    }
  }
};
</script>
<style scoped>
@media print {
  .no-print {
    display: none;
  }
}
</style>
